import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import TaskContainer from './TaskContainer';
import { getTodoUser } from '@/api/message';
import { valsubstr32addbr } from '@/utils/index';
import NoData from '@/components/NoData/NoData';
import { fmtReqParams, query } from './index';
export default {
  name: 'MyTask',
  components: {
    SearchForm: SearchForm,
    TaskContainer: TaskContainer,
    NoData: NoData
  },
  filters: {
    todoStatusFilter: function todoStatusFilter(status) {
      var todoStatusMap = {
        PENDING: '待办',
        COMPLETE: '已办',
        CLOSE: '已终止'
      };
      return todoStatusMap[status];
    }
  },
  props: {
    switchType: {
      type: String,
      default: '列表切换'
    },
    systemModuleArr: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    systemModuleMap: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      loading: false,
      todoFormData: [{
        title: '系统名称',
        key: 'systemId',
        multiple: true,
        placeholder: '请选择系统名称',
        type: 'select',
        value: null,
        selectData: JSON.parse(localStorage.getItem('SYSTEM_NAME_ARR')),
        selectedArr: []
      }, {
        title: '待办起止时间',
        key: 'date',
        placeholder: '请选择(当月/当季/上季度)',
        type: 'date2',
        value: [],
        selectData: [],
        selectedArr: []
      }, {
        title: '待办状态',
        key: 'todoStates',
        placeholder: '请选择待办状态',
        type: 'select',
        selectData: [{
          value: 'PENDING',
          label: '待办'
        }, {
          value: 'COMPLETE',
          label: '已办'
        }, {
          value: 'CLOSE',
          label: '已终止'
        }],
        selectedArr: ['PENDING'],
        multiple: true
      }],
      todoList: [],
      searchReq: query('todoStates'),
      total: 0,
      systemlist: JSON.parse(localStorage.getItem('SYSTEM_NAME_ARR')),
      showDialog: false,
      dialogUrl: '',
      todoTitle: '日常建议与反馈',
      todoId: null
    };
  },
  created: function created() {
    if (this.$route.query.item) {
      this.openTask(JSON.parse(this.$route.query.item));
    }
    window.addEventListener('message', this.handleMessage);
  },
  mounted: function mounted() {
    this.searchForm();
  },
  destroyed: function destroyed() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    openTask: function openTask(item) {
      // this.$API.postRequest({
      //       url:'/platform/todo/complete',
      //       data:{
      //         id:item.id
      //       }
      //     })
      if (item.todoStatus === 'CLOSE') {
        this.$message({
          message: '该待办任务已终止'
        });
        return;
      }
      if (item.url == null || item.url === '' || item.url === undefined) {
        return;
      }
      // if ([undefined, null, '0'].includes(item.openType)) {
      if (item.urlType === 'POPUP') {
        // 展示弹框
        this.$refs.TaskContainer.show(item);
      }
      // if (['1', '2'].includes(item.openType)) {
      if (item.urlType === 'JUMP') {
        // 展示页面
        this.$store.dispatch('settings/changeSetting', {
          key: 'iframeUrl',
          value: item.url
        });
      }
      if (item.urlType === 'DIALOG') {
        // 展示页面
        this.showDialog = true;
        this.dialogUrl = item.url;
        this.todoTitle = item.todoTitle;
      }
      if (item.urlType === 'NEW_PAGE') {
        window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(window.encodeURIComponent(item.url))));
      }
      this.searchForm();
    },
    rowClick: function rowClick(row) {
      this.openTask(row);
    },
    // 选择系统名称
    changeSelect: function changeSelect(_ref) {
      var key = _ref.key,
        selectedArr = _ref.selectedArr;
      if (key === 'systemId') {
        this.todoFormData[1].selectedArr = null;
        var systemModuleMap = this.systemModuleArr.find(function (_ref2) {
          var systemId = _ref2.dictGroup.systemId;
          return systemId === selectedArr;
        });
        this.todoFormData[1].selectData = systemModuleMap ? systemModuleMap.detailList.map(function (_ref3) {
          var dictCode = _ref3.dictCode,
            dictName = _ref3.dictName;
          return {
            label: dictCode,
            value: dictName
          };
        }) : [];
      }
    },
    searchForm: function searchForm() {
      this.searchReq = fmtReqParams(this.todoFormData, this.searchReq);
      this.getTodoUserList(this.searchReq);
    },
    getTodoUserList: function getTodoUserList(searchReq) {
      var _this = this;
      this.loading = true;
      getTodoUser(searchReq).then( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          var code, _res$result, list, total, taskMessage;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  code = res.code, _res$result = res.result, list = _res$result.list, total = _res$result.total;
                  if (!(code === '0000000000')) {
                    _context.next = 9;
                    break;
                  }
                  _context.next = 4;
                  return _this.$nextTick();
                case 4:
                  // eslint-disable-next-line no-return-assign
                  list.forEach(function (item) {
                    return item.systemModule = _this.systemModuleMap[item.systemModule];
                  });
                  Object.assign(_this, {
                    todoList: list,
                    total: total
                  });
                  taskMessage = '';
                  if (_this.searchReq.param.todoStates.length !== 1) {
                    taskMessage = "\u5171".concat(total, "\u4E2A\u4EFB\u52A1");
                  } else {
                    taskMessage = "".concat(total, "\u4E2A").concat(_this.searchReq.param.todoStates[0] === 'PENDING' ? '待办' : _this.searchReq.param.todoStates[0] === 'COMPLETE' ? '已办' : '已终止');
                  }
                  _this.$emit('changTaskCount', taskMessage);
                case 9:
                  _this.loading = false;
                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function () {
        _this.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.todoFormData.forEach(function (item) {
        if (item.key === 'systemModule') item.selectData = [];
        item.selectedArr = item.key === 'todoStates' ? [] : null;
        item.value = Array.isArray(item.value) ? [] : null;
      });
    },
    onSizeChange: function onSizeChange(pageSize) {
      this.searchReq.pageSize = pageSize;
      this.searchForm();
    },
    onCurrentChange: function onCurrentChange(pageNum) {
      this.searchReq.pageNum = pageNum;
      this.searchForm();
    },
    // tooltips过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    getsystemname: function getsystemname(val) {
      var systemname = null;
      // eslint-disable-next-line array-callback-return
      this.systemlist.filter(function (ele) {
        if (ele.value === val) {
          systemname = ele.label;
        }
      });
      return systemname;
    },
    handleMessage: function handleMessage(e) {
      var data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
      if (data.type === 'CLOSEMODAL') {
        this.showDialog = false;
        this.searchForm();
      }
      if (data.type === 'MSGSUCCESS') {
        this.$message({
          message: '回复评论成功！',
          type: 'success'
        });
        this.showDialog = false;
        this.$refs.TaskContainer.visible = false;
        this.searchForm();
      }
      if (data.type === 'APPROVESUCCESS') {
        this.$message({
          message: '审核成功！',
          type: 'success'
        });
        this.showDialog = false;
        this.searchForm();
      }
      if (data.type === 'APPROVEERROR') {
        this.$message({
          message: '审核失败！',
          type: 'warning'
        });
        this.showDialog = false;
        this.searchForm();
      }
      if (data.type === 'ERROR') {
        this.$message({
          message: '回复评论失败！',
          type: 'warning'
        });
        this.showDialog = false;
        this.searchForm();
      }
      // switch (data.type) {
      //   case "LOGOUT":
      //     store.dispatch('user/logoutClear')
      //     router.push(`/login?redirect=dashboard`)
      //     break;
      //   // case "REFRESH_TOKEN":
      //   //     store.commit("user/SET_TOKEN",data.data.token)
      //   //     store.commit("user/SET_REFRESH_TOKEN",data.data.refreshToken)
      //   //     console.log("父页面接收到了",data)
      //   //   break;
      // }
    }
  }
};